export default __webpack_public_path__ + "static/media/tipsIconRed.9aeaac11.svg";